/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdicionarMedicamentoDto,
  AtualizarMedicamentoDto,
  AtualizarTratamentoDto,
  AtualizarTratamentoTemplateDto,
  CorrigirVigenciaDto,
  CriarTratamentoDto,
  CriarTratamentoTemplateDto,
  ErroResponse,
  ListaDeTratamentoTemplatesResponse,
  PaginaDeTratamentosResponse,
  RegistrarVigenciaDto,
  SincronizacaoDeTratamentoResponse,
  SincronizarTratamentoDto,
  SugerirTratamentoDto,
  SugestaoDeTratamentoResponse,
  TratamentoResponse,
  TratamentoTemplateResponse,
  TratamentoVigenteControllerTratamentoVigenteParams,
  TratamentoVigenteResponse,
  TratamentosControllerListarParams
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTratamentoTemplatesControllerListarUrl = () => {




  return `/v1/tratamentos/templates`
}

/**
 * @summary Modelos DO VETERINÁRIO da sessão — não os da clínica
 */
export const tratamentoTemplatesControllerListar = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeTratamentoTemplatesResponse> => {

  return httpClient<ListaDeTratamentoTemplatesResponse>(getTratamentoTemplatesControllerListarUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTratamentoTemplatesControllerListarQueryKey = () => {
    return [
    `/v1/tratamentos/templates`
    ] as const;
    }


export const getTratamentoTemplatesControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError = ErroResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTratamentoTemplatesControllerListarQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>> = ({ signal }) => tratamentoTemplatesControllerListar({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TratamentoTemplatesControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>>
export type TratamentoTemplatesControllerListarQueryError = ErroResponse


export function useTratamentoTemplatesControllerListar<TData = Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError = ErroResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTratamentoTemplatesControllerListar<TData = Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTratamentoTemplatesControllerListar<TData = Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Modelos DO VETERINÁRIO da sessão — não os da clínica
 */

export function useTratamentoTemplatesControllerListar<TData = Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTratamentoTemplatesControllerListarQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTratamentoTemplatesControllerCriarUrl = () => {




  return `/v1/tratamentos/templates`
}

/**
 * @summary Cria um modelo. O nome é único por veterinário. A `estrutura` guarda fármaco, via, frequência e dose SUGERIDA — o valor final é sempre do clínico.
 */
export const tratamentoTemplatesControllerCriar = async (criarTratamentoTemplateDto: CriarTratamentoTemplateDto, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoTemplateResponse> => {

  return httpClient<TratamentoTemplateResponse>(getTratamentoTemplatesControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarTratamentoTemplateDto)
  }
);}





export const getTratamentoTemplatesControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerCriar>>, TError,{data: CriarTratamentoTemplateDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerCriar>>, TError,{data: CriarTratamentoTemplateDto}, TContext> => {

const mutationKey = ['tratamentoTemplatesControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentoTemplatesControllerCriar>>, {data: CriarTratamentoTemplateDto}> = (props) => {
          const {data} = props ?? {};

          return  tratamentoTemplatesControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentoTemplatesControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentoTemplatesControllerCriar>>>
    export type TratamentoTemplatesControllerCriarMutationBody = CriarTratamentoTemplateDto
    export type TratamentoTemplatesControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria um modelo. O nome é único por veterinário. A `estrutura` guarda fármaco, via, frequência e dose SUGERIDA — o valor final é sempre do clínico.
 */
export const useTratamentoTemplatesControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerCriar>>, TError,{data: CriarTratamentoTemplateDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentoTemplatesControllerCriar>>,
        TError,
        {data: CriarTratamentoTemplateDto},
        TContext
      > => {
      return useMutation(getTratamentoTemplatesControllerCriarMutationOptions(options), queryClient);
    }
    export const getTratamentoTemplatesControllerObterUrl = (id: string,) => {




  return `/v1/tratamentos/templates/${id}`
}

/**
 * @summary Detalha um modelo próprio. Modelo de outro veterinário responde 404, igual ao inexistente.
 */
export const tratamentoTemplatesControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoTemplateResponse> => {

  return httpClient<TratamentoTemplateResponse>(getTratamentoTemplatesControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTratamentoTemplatesControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/tratamentos/templates/${id}`
    ] as const;
    }


export const getTratamentoTemplatesControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTratamentoTemplatesControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>> = ({ signal }) => tratamentoTemplatesControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TratamentoTemplatesControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>>
export type TratamentoTemplatesControllerObterQueryError = ErroResponse


export function useTratamentoTemplatesControllerObter<TData = Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTratamentoTemplatesControllerObter<TData = Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTratamentoTemplatesControllerObter<TData = Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um modelo próprio. Modelo de outro veterinário responde 404, igual ao inexistente.
 */

export function useTratamentoTemplatesControllerObter<TData = Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTratamentoTemplatesControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTratamentoTemplatesControllerAtualizarUrl = (id: string,) => {




  return `/v1/tratamentos/templates/${id}`
}

/**
 * @summary Edita um modelo próprio. `estrutura`, quando vem, SUBSTITUI a anterior por inteiro.
 */
export const tratamentoTemplatesControllerAtualizar = async (id: string,
    atualizarTratamentoTemplateDto: AtualizarTratamentoTemplateDto, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoTemplateResponse> => {

  return httpClient<TratamentoTemplateResponse>(getTratamentoTemplatesControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarTratamentoTemplateDto)
  }
);}





export const getTratamentoTemplatesControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerAtualizar>>, TError,{id: string;data: AtualizarTratamentoTemplateDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerAtualizar>>, TError,{id: string;data: AtualizarTratamentoTemplateDto}, TContext> => {

const mutationKey = ['tratamentoTemplatesControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentoTemplatesControllerAtualizar>>, {id: string;data: AtualizarTratamentoTemplateDto}> = (props) => {
          const {id,data} = props ?? {};

          return  tratamentoTemplatesControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentoTemplatesControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentoTemplatesControllerAtualizar>>>
    export type TratamentoTemplatesControllerAtualizarMutationBody = AtualizarTratamentoTemplateDto
    export type TratamentoTemplatesControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita um modelo próprio. `estrutura`, quando vem, SUBSTITUI a anterior por inteiro.
 */
export const useTratamentoTemplatesControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerAtualizar>>, TError,{id: string;data: AtualizarTratamentoTemplateDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentoTemplatesControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarTratamentoTemplateDto},
        TContext
      > => {
      return useMutation(getTratamentoTemplatesControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getTratamentoTemplatesControllerExcluirUrl = (id: string,) => {




  return `/v1/tratamentos/templates/${id}`
}

/**
 * @summary Exclui o modelo. Delete físico — nenhum tratamento aponta para ele, a estrutura é copiada no uso.
 */
export const tratamentoTemplatesControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getTratamentoTemplatesControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTratamentoTemplatesControllerExcluirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['tratamentoTemplatesControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentoTemplatesControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  tratamentoTemplatesControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentoTemplatesControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentoTemplatesControllerExcluir>>>

    export type TratamentoTemplatesControllerExcluirMutationError = ErroResponse

    /**
 * @summary Exclui o modelo. Delete físico — nenhum tratamento aponta para ele, a estrutura é copiada no uso.
 */
export const useTratamentoTemplatesControllerExcluir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentoTemplatesControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentoTemplatesControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getTratamentoTemplatesControllerExcluirMutationOptions(options), queryClient);
    }
    export const getSugestaoDeTratamentoControllerSugerirUrl = () => {




  return `/v1/tratamentos/sugerir`
}

/**
 * @summary Estrutura um histórico colado em uma sugestão de tratamento, casada contra o catálogo. NÃO grava nada — quem persiste é o POST /v1/tratamentos, com a confirmação do veterinário.
 */
export const sugestaoDeTratamentoControllerSugerir = async (sugerirTratamentoDto: SugerirTratamentoDto, options?: Parameters<typeof httpClient>[1]): Promise<SugestaoDeTratamentoResponse> => {

  return httpClient<SugestaoDeTratamentoResponse>(getSugestaoDeTratamentoControllerSugerirUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sugerirTratamentoDto)
  }
);}





export const getSugestaoDeTratamentoControllerSugerirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sugestaoDeTratamentoControllerSugerir>>, TError,{data: SugerirTratamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof sugestaoDeTratamentoControllerSugerir>>, TError,{data: SugerirTratamentoDto}, TContext> => {

const mutationKey = ['sugestaoDeTratamentoControllerSugerir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sugestaoDeTratamentoControllerSugerir>>, {data: SugerirTratamentoDto}> = (props) => {
          const {data} = props ?? {};

          return  sugestaoDeTratamentoControllerSugerir(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SugestaoDeTratamentoControllerSugerirMutationResult = NonNullable<Awaited<ReturnType<typeof sugestaoDeTratamentoControllerSugerir>>>
    export type SugestaoDeTratamentoControllerSugerirMutationBody = SugerirTratamentoDto
    export type SugestaoDeTratamentoControllerSugerirMutationError = ErroResponse

    /**
 * @summary Estrutura um histórico colado em uma sugestão de tratamento, casada contra o catálogo. NÃO grava nada — quem persiste é o POST /v1/tratamentos, com a confirmação do veterinário.
 */
export const useSugestaoDeTratamentoControllerSugerir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sugestaoDeTratamentoControllerSugerir>>, TError,{data: SugerirTratamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sugestaoDeTratamentoControllerSugerir>>,
        TError,
        {data: SugerirTratamentoDto},
        TContext
      > => {
      return useMutation(getSugestaoDeTratamentoControllerSugerirMutationOptions(options), queryClient);
    }
    export const getTratamentosControllerListarUrl = (params?: TratamentosControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/tratamentos?${stringifiedParams}` : `/v1/tratamentos`
}

/**
 * @summary Lista os tratamentos do ambiente, do mais recente
 */
export const tratamentosControllerListar = async (params?: TratamentosControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeTratamentosResponse> => {

  return httpClient<PaginaDeTratamentosResponse>(getTratamentosControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTratamentosControllerListarQueryKey = (params?: TratamentosControllerListarParams,) => {
    return [
    `/v1/tratamentos`, ...(params ? [params] : [])
    ] as const;
    }


export const getTratamentosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof tratamentosControllerListar>>, TError = ErroResponse>(params?: TratamentosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTratamentosControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tratamentosControllerListar>>> = ({ signal }) => tratamentosControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TratamentosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerListar>>>
export type TratamentosControllerListarQueryError = ErroResponse


export function useTratamentosControllerListar<TData = Awaited<ReturnType<typeof tratamentosControllerListar>>, TError = ErroResponse>(
 params: undefined |  TratamentosControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tratamentosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof tratamentosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTratamentosControllerListar<TData = Awaited<ReturnType<typeof tratamentosControllerListar>>, TError = ErroResponse>(
 params?: TratamentosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tratamentosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof tratamentosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTratamentosControllerListar<TData = Awaited<ReturnType<typeof tratamentosControllerListar>>, TError = ErroResponse>(
 params?: TratamentosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os tratamentos do ambiente, do mais recente
 */

export function useTratamentosControllerListar<TData = Awaited<ReturnType<typeof tratamentosControllerListar>>, TError = ErroResponse>(
 params?: TratamentosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTratamentosControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTratamentosControllerCriarUrl = () => {




  return `/v1/tratamentos`
}

/**
 * @summary Cria o tratamento com os medicamentos e a dose inicial de cada um, numa transação só. Exige ao menos um medicamento — "sem tratamento" se declara no prontuário.
 */
export const tratamentosControllerCriar = async (criarTratamentoDto: CriarTratamentoDto, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoResponse> => {

  return httpClient<TratamentoResponse>(getTratamentosControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarTratamentoDto)
  }
);}





export const getTratamentosControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerCriar>>, TError,{data: CriarTratamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerCriar>>, TError,{data: CriarTratamentoDto}, TContext> => {

const mutationKey = ['tratamentosControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentosControllerCriar>>, {data: CriarTratamentoDto}> = (props) => {
          const {data} = props ?? {};

          return  tratamentosControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentosControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerCriar>>>
    export type TratamentosControllerCriarMutationBody = CriarTratamentoDto
    export type TratamentosControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria o tratamento com os medicamentos e a dose inicial de cada um, numa transação só. Exige ao menos um medicamento — "sem tratamento" se declara no prontuário.
 */
export const useTratamentosControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerCriar>>, TError,{data: CriarTratamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentosControllerCriar>>,
        TError,
        {data: CriarTratamentoDto},
        TContext
      > => {
      return useMutation(getTratamentosControllerCriarMutationOptions(options), queryClient);
    }
    export const getTratamentosControllerObterUrl = (id: string,) => {




  return `/v1/tratamentos/${id}`
}

/**
 * @summary Detalha um tratamento, com o histórico de dose de cada medicamento
 */
export const tratamentosControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoResponse> => {

  return httpClient<TratamentoResponse>(getTratamentosControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTratamentosControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/tratamentos/${id}`
    ] as const;
    }


export const getTratamentosControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof tratamentosControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTratamentosControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tratamentosControllerObter>>> = ({ signal }) => tratamentosControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TratamentosControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerObter>>>
export type TratamentosControllerObterQueryError = ErroResponse


export function useTratamentosControllerObter<TData = Awaited<ReturnType<typeof tratamentosControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tratamentosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof tratamentosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTratamentosControllerObter<TData = Awaited<ReturnType<typeof tratamentosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tratamentosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof tratamentosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTratamentosControllerObter<TData = Awaited<ReturnType<typeof tratamentosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um tratamento, com o histórico de dose de cada medicamento
 */

export function useTratamentosControllerObter<TData = Awaited<ReturnType<typeof tratamentosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTratamentosControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTratamentosControllerAtualizarUrl = (id: string,) => {




  return `/v1/tratamentos/${id}`
}

/**
 * @summary Edita o cabeçalho. Preencher `encerradoEm` encerra; `null` reabre.
 */
export const tratamentosControllerAtualizar = async (id: string,
    atualizarTratamentoDto: AtualizarTratamentoDto, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoResponse> => {

  return httpClient<TratamentoResponse>(getTratamentosControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarTratamentoDto)
  }
);}





export const getTratamentosControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerAtualizar>>, TError,{id: string;data: AtualizarTratamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerAtualizar>>, TError,{id: string;data: AtualizarTratamentoDto}, TContext> => {

const mutationKey = ['tratamentosControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentosControllerAtualizar>>, {id: string;data: AtualizarTratamentoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  tratamentosControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentosControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerAtualizar>>>
    export type TratamentosControllerAtualizarMutationBody = AtualizarTratamentoDto
    export type TratamentosControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita o cabeçalho. Preencher `encerradoEm` encerra; `null` reabre.
 */
export const useTratamentosControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerAtualizar>>, TError,{id: string;data: AtualizarTratamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentosControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarTratamentoDto},
        TContext
      > => {
      return useMutation(getTratamentosControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getTratamentosControllerExcluirUrl = (id: string,) => {




  return `/v1/tratamentos/${id}`
}

/**
 * @summary Exclusão lógica. O histórico de dose continua no banco.
 */
export const tratamentosControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getTratamentosControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTratamentosControllerExcluirMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['tratamentosControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentosControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  tratamentosControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentosControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerExcluir>>>

    export type TratamentosControllerExcluirMutationError = unknown

    /**
 * @summary Exclusão lógica. O histórico de dose continua no banco.
 */
export const useTratamentosControllerExcluir = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentosControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getTratamentosControllerExcluirMutationOptions(options), queryClient);
    }
    export const getTratamentosControllerAdicionarMedicamentoUrl = (id: string,) => {




  return `/v1/tratamentos/${id}/medicamentos`
}

/**
 * @summary Acrescenta um fármaco ao tratamento, já com a dose inicial. Ela vale a partir de HOJE — dizer que valia desde o início do tratamento inventaria exposição que não houve.
 */
export const tratamentosControllerAdicionarMedicamento = async (id: string,
    adicionarMedicamentoDto: AdicionarMedicamentoDto, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoResponse> => {

  return httpClient<TratamentoResponse>(getTratamentosControllerAdicionarMedicamentoUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adicionarMedicamentoDto)
  }
);}





export const getTratamentosControllerAdicionarMedicamentoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerAdicionarMedicamento>>, TError,{id: string;data: AdicionarMedicamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerAdicionarMedicamento>>, TError,{id: string;data: AdicionarMedicamentoDto}, TContext> => {

const mutationKey = ['tratamentosControllerAdicionarMedicamento'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentosControllerAdicionarMedicamento>>, {id: string;data: AdicionarMedicamentoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  tratamentosControllerAdicionarMedicamento(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentosControllerAdicionarMedicamentoMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerAdicionarMedicamento>>>
    export type TratamentosControllerAdicionarMedicamentoMutationBody = AdicionarMedicamentoDto
    export type TratamentosControllerAdicionarMedicamentoMutationError = unknown

    /**
 * @summary Acrescenta um fármaco ao tratamento, já com a dose inicial. Ela vale a partir de HOJE — dizer que valia desde o início do tratamento inventaria exposição que não houve.
 */
export const useTratamentosControllerAdicionarMedicamento = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerAdicionarMedicamento>>, TError,{id: string;data: AdicionarMedicamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentosControllerAdicionarMedicamento>>,
        TError,
        {id: string;data: AdicionarMedicamentoDto},
        TContext
      > => {
      return useMutation(getTratamentosControllerAdicionarMedicamentoMutationOptions(options), queryClient);
    }
    export const getTratamentosControllerAtualizarMedicamentoUrl = (id: string,
    medicamentoId: string,) => {




  return `/v1/tratamentos/${id}/medicamentos/${medicamentoId}`
}

/**
 * @summary Ordem de exibição e encerramento. A IDENTIDADE do fármaco é imutável — trocá-lo é outro medicamento; dose, frequência e via vivem na vigência, porque mudá-las é evento datado.
 */
export const tratamentosControllerAtualizarMedicamento = async (id: string,
    medicamentoId: string,
    atualizarMedicamentoDto: AtualizarMedicamentoDto, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoResponse> => {

  return httpClient<TratamentoResponse>(getTratamentosControllerAtualizarMedicamentoUrl(id,medicamentoId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarMedicamentoDto)
  }
);}





export const getTratamentosControllerAtualizarMedicamentoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerAtualizarMedicamento>>, TError,{id: string;medicamentoId: string;data: AtualizarMedicamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerAtualizarMedicamento>>, TError,{id: string;medicamentoId: string;data: AtualizarMedicamentoDto}, TContext> => {

const mutationKey = ['tratamentosControllerAtualizarMedicamento'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentosControllerAtualizarMedicamento>>, {id: string;medicamentoId: string;data: AtualizarMedicamentoDto}> = (props) => {
          const {id,medicamentoId,data} = props ?? {};

          return  tratamentosControllerAtualizarMedicamento(id,medicamentoId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentosControllerAtualizarMedicamentoMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerAtualizarMedicamento>>>
    export type TratamentosControllerAtualizarMedicamentoMutationBody = AtualizarMedicamentoDto
    export type TratamentosControllerAtualizarMedicamentoMutationError = ErroResponse

    /**
 * @summary Ordem de exibição e encerramento. A IDENTIDADE do fármaco é imutável — trocá-lo é outro medicamento; dose, frequência e via vivem na vigência, porque mudá-las é evento datado.
 */
export const useTratamentosControllerAtualizarMedicamento = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerAtualizarMedicamento>>, TError,{id: string;medicamentoId: string;data: AtualizarMedicamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentosControllerAtualizarMedicamento>>,
        TError,
        {id: string;medicamentoId: string;data: AtualizarMedicamentoDto},
        TContext
      > => {
      return useMutation(getTratamentosControllerAtualizarMedicamentoMutationOptions(options), queryClient);
    }
    export const getTratamentosControllerRegistrarVigenciaUrl = (id: string,
    medicamentoId: string,) => {




  return `/v1/tratamentos/${id}/medicamentos/${medicamentoId}/vigencias`
}

/**
 * @summary AJUSTA A DOSE inserindo uma vigência nova. A anterior se fecha sozinha — o fim de uma é o início da próxima. `vigenteDe` omitido = hoje.
 */
export const tratamentosControllerRegistrarVigencia = async (id: string,
    medicamentoId: string,
    registrarVigenciaDto: RegistrarVigenciaDto, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoResponse> => {

  return httpClient<TratamentoResponse>(getTratamentosControllerRegistrarVigenciaUrl(id,medicamentoId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registrarVigenciaDto)
  }
);}





export const getTratamentosControllerRegistrarVigenciaMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerRegistrarVigencia>>, TError,{id: string;medicamentoId: string;data: RegistrarVigenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerRegistrarVigencia>>, TError,{id: string;medicamentoId: string;data: RegistrarVigenciaDto}, TContext> => {

const mutationKey = ['tratamentosControllerRegistrarVigencia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentosControllerRegistrarVigencia>>, {id: string;medicamentoId: string;data: RegistrarVigenciaDto}> = (props) => {
          const {id,medicamentoId,data} = props ?? {};

          return  tratamentosControllerRegistrarVigencia(id,medicamentoId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentosControllerRegistrarVigenciaMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerRegistrarVigencia>>>
    export type TratamentosControllerRegistrarVigenciaMutationBody = RegistrarVigenciaDto
    export type TratamentosControllerRegistrarVigenciaMutationError = ErroResponse

    /**
 * @summary AJUSTA A DOSE inserindo uma vigência nova. A anterior se fecha sozinha — o fim de uma é o início da próxima. `vigenteDe` omitido = hoje.
 */
export const useTratamentosControllerRegistrarVigencia = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerRegistrarVigencia>>, TError,{id: string;medicamentoId: string;data: RegistrarVigenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentosControllerRegistrarVigencia>>,
        TError,
        {id: string;medicamentoId: string;data: RegistrarVigenciaDto},
        TContext
      > => {
      return useMutation(getTratamentosControllerRegistrarVigenciaMutationOptions(options), queryClient);
    }
    export const getTratamentosControllerCorrigirVigenciaUrl = (id: string,
    medicamentoId: string,
    vigenciaId: string,) => {




  return `/v1/tratamentos/${id}/medicamentos/${medicamentoId}/vigencias/${vigenciaId}`
}

/**
 * @summary Corrige ERRO DE DIGITAÇÃO da dose mais recente. Não é ajuste de dose — para isso, POST. Qualquer vigência que não seja a última responde 409.
 */
export const tratamentosControllerCorrigirVigencia = async (id: string,
    medicamentoId: string,
    vigenciaId: string,
    corrigirVigenciaDto: CorrigirVigenciaDto, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoResponse> => {

  return httpClient<TratamentoResponse>(getTratamentosControllerCorrigirVigenciaUrl(id,medicamentoId,vigenciaId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(corrigirVigenciaDto)
  }
);}





export const getTratamentosControllerCorrigirVigenciaMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerCorrigirVigencia>>, TError,{id: string;medicamentoId: string;vigenciaId: string;data: CorrigirVigenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerCorrigirVigencia>>, TError,{id: string;medicamentoId: string;vigenciaId: string;data: CorrigirVigenciaDto}, TContext> => {

const mutationKey = ['tratamentosControllerCorrigirVigencia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentosControllerCorrigirVigencia>>, {id: string;medicamentoId: string;vigenciaId: string;data: CorrigirVigenciaDto}> = (props) => {
          const {id,medicamentoId,vigenciaId,data} = props ?? {};

          return  tratamentosControllerCorrigirVigencia(id,medicamentoId,vigenciaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentosControllerCorrigirVigenciaMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerCorrigirVigencia>>>
    export type TratamentosControllerCorrigirVigenciaMutationBody = CorrigirVigenciaDto
    export type TratamentosControllerCorrigirVigenciaMutationError = ErroResponse

    /**
 * @summary Corrige ERRO DE DIGITAÇÃO da dose mais recente. Não é ajuste de dose — para isso, POST. Qualquer vigência que não seja a última responde 409.
 */
export const useTratamentosControllerCorrigirVigencia = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerCorrigirVigencia>>, TError,{id: string;medicamentoId: string;vigenciaId: string;data: CorrigirVigenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentosControllerCorrigirVigencia>>,
        TError,
        {id: string;medicamentoId: string;vigenciaId: string;data: CorrigirVigenciaDto},
        TContext
      > => {
      return useMutation(getTratamentosControllerCorrigirVigenciaMutationOptions(options), queryClient);
    }
    export const getTratamentosControllerRemoverVigenciaUrl = (id: string,
    medicamentoId: string,
    vigenciaId: string,) => {




  return `/v1/tratamentos/${id}/medicamentos/${medicamentoId}/vigencias/${vigenciaId}`
}

/**
 * @summary Remove a dose mais recente — o lançamento que não devia existir. Nunca a última que resta: para tirar o fármaco do tratamento, encerre-o.
 */
export const tratamentosControllerRemoverVigencia = async (id: string,
    medicamentoId: string,
    vigenciaId: string, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoResponse> => {

  return httpClient<TratamentoResponse>(getTratamentosControllerRemoverVigenciaUrl(id,medicamentoId,vigenciaId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTratamentosControllerRemoverVigenciaMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerRemoverVigencia>>, TError,{id: string;medicamentoId: string;vigenciaId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerRemoverVigencia>>, TError,{id: string;medicamentoId: string;vigenciaId: string}, TContext> => {

const mutationKey = ['tratamentosControllerRemoverVigencia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentosControllerRemoverVigencia>>, {id: string;medicamentoId: string;vigenciaId: string}> = (props) => {
          const {id,medicamentoId,vigenciaId} = props ?? {};

          return  tratamentosControllerRemoverVigencia(id,medicamentoId,vigenciaId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentosControllerRemoverVigenciaMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerRemoverVigencia>>>

    export type TratamentosControllerRemoverVigenciaMutationError = ErroResponse

    /**
 * @summary Remove a dose mais recente — o lançamento que não devia existir. Nunca a última que resta: para tirar o fármaco do tratamento, encerre-o.
 */
export const useTratamentosControllerRemoverVigencia = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerRemoverVigencia>>, TError,{id: string;medicamentoId: string;vigenciaId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentosControllerRemoverVigencia>>,
        TError,
        {id: string;medicamentoId: string;vigenciaId: string},
        TContext
      > => {
      return useMutation(getTratamentosControllerRemoverVigenciaMutationOptions(options), queryClient);
    }
    export const getTratamentosControllerSincronizarUrl = (id: string,) => {




  return `/v1/tratamentos/${id}/sincronizar`
}

/**
 * @summary O "salvar" do prontuário: recebe a LISTA INTEIRA de medicamentos como ficou no editor e grava só a diferença contra o que valia em `atendidoEm`. Nada mudou → nenhuma linha nova (`semAlteracao: true`, não é erro). Mudou dose, dose/kg, frequência, via ou apresentação → vigência nova; fármaco novo → medicamento novo; fármaco fora da lista → `encerradoEm`. Nada é apagado, e tudo numa transação só.
 */
export const tratamentosControllerSincronizar = async (id: string,
    sincronizarTratamentoDto: SincronizarTratamentoDto, options?: Parameters<typeof httpClient>[1]): Promise<SincronizacaoDeTratamentoResponse> => {

  return httpClient<SincronizacaoDeTratamentoResponse>(getTratamentosControllerSincronizarUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sincronizarTratamentoDto)
  }
);}





export const getTratamentosControllerSincronizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerSincronizar>>, TError,{id: string;data: SincronizarTratamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerSincronizar>>, TError,{id: string;data: SincronizarTratamentoDto}, TContext> => {

const mutationKey = ['tratamentosControllerSincronizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tratamentosControllerSincronizar>>, {id: string;data: SincronizarTratamentoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  tratamentosControllerSincronizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TratamentosControllerSincronizarMutationResult = NonNullable<Awaited<ReturnType<typeof tratamentosControllerSincronizar>>>
    export type TratamentosControllerSincronizarMutationBody = SincronizarTratamentoDto
    export type TratamentosControllerSincronizarMutationError = ErroResponse

    /**
 * @summary O "salvar" do prontuário: recebe a LISTA INTEIRA de medicamentos como ficou no editor e grava só a diferença contra o que valia em `atendidoEm`. Nada mudou → nenhuma linha nova (`semAlteracao: true`, não é erro). Mudou dose, dose/kg, frequência, via ou apresentação → vigência nova; fármaco novo → medicamento novo; fármaco fora da lista → `encerradoEm`. Nada é apagado, e tudo numa transação só.
 */
export const useTratamentosControllerSincronizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tratamentosControllerSincronizar>>, TError,{id: string;data: SincronizarTratamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tratamentosControllerSincronizar>>,
        TError,
        {id: string;data: SincronizarTratamentoDto},
        TContext
      > => {
      return useMutation(getTratamentosControllerSincronizarMutationOptions(options), queryClient);
    }
    export const getTratamentoVigenteControllerTratamentoVigenteUrl = (pacienteId: string,
    params?: TratamentoVigenteControllerTratamentoVigenteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/pacientes/${pacienteId}/tratamento-vigente?${stringifiedParams}` : `/v1/pacientes/${pacienteId}/tratamento-vigente`
}

/**
 * @summary O tratamento em curso do paciente, com a dose que vale na data pedida — é o que preenche o editor do prontuário. Sem tratamento em curso, `{ tratamento: null }` com 200: "este animal não está medicado" é resposta clínica, não erro.
 */
export const tratamentoVigenteControllerTratamentoVigente = async (pacienteId: string,
    params?: TratamentoVigenteControllerTratamentoVigenteParams, options?: Parameters<typeof httpClient>[1]): Promise<TratamentoVigenteResponse> => {

  return httpClient<TratamentoVigenteResponse>(getTratamentoVigenteControllerTratamentoVigenteUrl(pacienteId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTratamentoVigenteControllerTratamentoVigenteQueryKey = (pacienteId: string,
    params?: TratamentoVigenteControllerTratamentoVigenteParams,) => {
    return [
    `/v1/pacientes/${pacienteId}/tratamento-vigente`, ...(params ? [params] : [])
    ] as const;
    }


export const getTratamentoVigenteControllerTratamentoVigenteQueryOptions = <TData = Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError = ErroResponse>(pacienteId: string,
    params?: TratamentoVigenteControllerTratamentoVigenteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTratamentoVigenteControllerTratamentoVigenteQueryKey(pacienteId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>> = ({ signal }) => tratamentoVigenteControllerTratamentoVigente(pacienteId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pacienteId !== null && pacienteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TratamentoVigenteControllerTratamentoVigenteQueryResult = NonNullable<Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>>
export type TratamentoVigenteControllerTratamentoVigenteQueryError = ErroResponse


export function useTratamentoVigenteControllerTratamentoVigente<TData = Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError = ErroResponse>(
 pacienteId: string,
    params: undefined |  TratamentoVigenteControllerTratamentoVigenteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>,
          TError,
          Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTratamentoVigenteControllerTratamentoVigente<TData = Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError = ErroResponse>(
 pacienteId: string,
    params?: TratamentoVigenteControllerTratamentoVigenteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>,
          TError,
          Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTratamentoVigenteControllerTratamentoVigente<TData = Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError = ErroResponse>(
 pacienteId: string,
    params?: TratamentoVigenteControllerTratamentoVigenteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary O tratamento em curso do paciente, com a dose que vale na data pedida — é o que preenche o editor do prontuário. Sem tratamento em curso, `{ tratamento: null }` com 200: "este animal não está medicado" é resposta clínica, não erro.
 */

export function useTratamentoVigenteControllerTratamentoVigente<TData = Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError = ErroResponse>(
 pacienteId: string,
    params?: TratamentoVigenteControllerTratamentoVigenteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tratamentoVigenteControllerTratamentoVigente>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTratamentoVigenteControllerTratamentoVigenteQueryOptions(pacienteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






